









































































import { ScheduleModalVue } from "fs-pb-vue2/vueModels/contracts/ScheduleModalVue";
import CustomTable from "fs-pb-vue2/components/CustomTable.vue";
import BackLink from "@/components/app/BackLink.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: { BackLink }
})
export default class ScheduleModal extends ScheduleModalVue {
  get totalPercSumm(): string {
    return this.contract ? this.$options.filters.sum(this.contract.CreditSchedule.ScheduleList.reduce((acc, item) => acc += item.PercSum, 0), false, this.contract.Currency) : 0;
  }
}
